import { StateCreator } from 'zustand';
import { IAppStore } from '../../../IAppStore';
import TopicSubLayerSettingsSlice, {
  TopicSubLayerSettingsProps,
} from './TopicLayerSettingsSlice';
import { MapLayerSetting, SubLayerProps } from '../api/Contracts';

export const defaultTopicLayerSettingsProps: TopicSubLayerSettingsProps = {
  topicSubLayerSetting: {},
  currentTopicLayerId: null,
  newAddedTopicLayer: null,
  previewLayer: null,
};

const createTopicLayerSettingsSlice: StateCreator<
  IAppStore,
  [],
  [],
  TopicSubLayerSettingsSlice
> = (set, get) => ({
  ...defaultTopicLayerSettingsProps,

  setSubLayerSetting: (
    topicLayerId: string,
    setting: Record<number, MapLayerSetting>,
  ) => {
    const { topicSubLayerSetting } = get();

    const subLayerSettings: SubLayerProps[] = Object.values(setting).map(
      ({ id, isEnabled, isExpanded }) => ({
        id,
        isEnabled,
        isExpanded,
      }),
    );

    set({
      topicSubLayerSetting: {
        ...topicSubLayerSetting,
        [topicLayerId]: subLayerSettings,
      },
    });
  },

  removeSubTopicLayerSetting: (topicLayerId: string) => {
    const { topicSubLayerSetting, topicLayerSettings, selectedTopicLayers } = get();

    const updatedSubLayerSetting = { ...topicSubLayerSetting };
    delete updatedSubLayerSetting[topicLayerId];

    const updatedLayerSettings = { ...topicLayerSettings };
    delete updatedLayerSettings[topicLayerId];

    set({
      selectedTopicLayers: selectedTopicLayers.filter((id) => id !== topicLayerId),
      topicLayerSettings: updatedLayerSettings,
      topicSubLayerSetting: updatedSubLayerSetting,
    });
  },

  setCurrentTopicLayerId: (topicLayerId: string) =>
    set({ currentTopicLayerId: topicLayerId }),
  setNewAddedTopicLayer: (topicLayerId: string) =>
    set({ newAddedTopicLayer: topicLayerId }),

  setPreviewLayer: (previewLayer: string | undefined) => set({ previewLayer }),
  clearTopicLayers: () => set({ selectedTopicLayers: [], topicSubLayerSetting: {} }),
});

export default createTopicLayerSettingsSlice;
